define('vspot-angular/resources/wepay-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // See user-resource for general documentation
        return $resource('api/wepay/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                save: {
                    method: 'POST'
                },
                
                get: {
                    method: 'GET',
                    params: {
                        controller: 'get_wampum_data'
                    }
                },

                query: {
                    method: 'GET',
                    cache:  false
                },

                accountRegister: {
                    method: 'GET',
                    params: {
                        controller: 'account_register'
                    }
                },

                accountBalance: {
                    method: 'GET',
                    params: {
                        controller: 'account_balance'
                    }
                },

                updateAmounts: {
                    method: 'POST',
                    params: {
                        controller: 'set_wampum_amounts'
                    }
                },

                totalGrossSalesVolunteer: {
                    method: 'POST',
                    params: {
                        controller: 'total_gross_sales_volunteer'
                    }
                },

                totalGrossSalesOrganizer: {
                    method: 'POST',
                    params: {
                        controller: 'total_gross_sales_organizer'
                    }
                },
                volunteerEmbeddedCheckout: {
                    method: 'POST',
                    params: {
                        controller: 'volunteer_embedded_checkout'
                    }
                },
            }
        );
    }];
});


